import styled from 'styled-components'

interface PlaceholderRadioButtonProps {
  isSelected: boolean
}

export const MatchProfessionalsTitle = styled.span`
  display: flex;
  align-items: center;
  gap: 20px;

  div {
    display: flex;
    flex-direction: column;
    gap: 5px;

    p {
      color: #898989;
    }
  }
`

export const ModalContainer = styled.div`
  padding: 35px 60px;

  @media (max-width: 768px) {
    padding: 10px 20px;
  }
`

export const MatchProfessionalsContainer = styled.div`
  width: 100%;
  
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const StepsContainer = styled.div`
  margin-bottom: 5px;

  p {
    color: #FD9476;
  }
`

export const QuestionContainer = styled.div`
  width: 100%;

  h3, textarea {
    margin-bottom: 20px;
  }

`

export const ComplementaryInfoContainer = styled.div`
  margin-bottom: 20px;
  color: #4B4B4B;
`

export const Footer = styled.div`
  padding: 20px 0 0;

  width: 100%;

  display: flex;
  gap: 10px;

  button {
    width: 100%;
    border-radius: 9999px;

    &:last-of-type {
      background: #FD9476;
  
      &:hover {
        background: #FD9476;
      }

      &:disabled {
        background: #ebebeb;
      }
    }
  }
`

export const RadioContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const RadioButtonTextWrapper = styled.div`
  flex: 1;
`

export const EmptyIcon = styled.span`
  width: 24px;
  height: 24px;
`

export const RadioButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const PlaceholderRadioButton = styled.div<PlaceholderRadioButtonProps>`
  border: 1px solid ${({ isSelected }) => isSelected ? '#FD9476' : '#C1C1C1'};
  background: transparent;
  border-radius: 9999px;
  width: 100%;

  button {
    border: none;
    border-radius: 9999px;
    background: none;

    &:hover {
      background: #F5F5F5;
    }
  }
`